/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Loading_LabelInputs */

const en_style_guide_manager_loading_label = /** @type {(inputs: Style_Guide_Manager_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading guides... please wait...`)
};

const fr_style_guide_manager_loading_label = /** @type {(inputs: Style_Guide_Manager_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des guides... veuillez patienter...`)
};

const de_style_guide_manager_loading_label = /** @type {(inputs: Style_Guide_Manager_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anleitungen werden geladen... Bitte warten...`)
};

const it_style_guide_manager_loading_label = /** @type {(inputs: Style_Guide_Manager_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento delle guide... attendere prego...`)
};

const ru_style_guide_manager_loading_label = /** @type {(inputs: Style_Guide_Manager_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка инструкций... пожалуйста, подождите...`)
};

const es_style_guide_manager_loading_label = /** @type {(inputs: Style_Guide_Manager_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando guías... por favor espere...`)
};

const zh_cn2_style_guide_manager_loading_label = /** @type {(inputs: Style_Guide_Manager_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载指南……请稍候……`)
};

const ja_style_guide_manager_loading_label = /** @type {(inputs: Style_Guide_Manager_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガイドを読み込んでいます...お待ちください...`)
};

const hi_style_guide_manager_loading_label = /** @type {(inputs: Style_Guide_Manager_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गाइड लोड हो रहे हैं... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_style_guide_manager_loading_label = /** @type {(inputs: Style_Guide_Manager_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando guias... aguarde...`)
};

/**
* | output |
* | --- |
* | "Loading guides... please wait..." |
*
* @param {Style_Guide_Manager_Loading_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_loading_label = /** @type {((inputs?: Style_Guide_Manager_Loading_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Loading_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_loading_label(inputs)
	if (locale === "de") return de_style_guide_manager_loading_label(inputs)
	if (locale === "it") return it_style_guide_manager_loading_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_loading_label(inputs)
	if (locale === "es") return es_style_guide_manager_loading_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_loading_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_loading_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_loading_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_loading_label(inputs)
	return en_style_guide_manager_loading_label(inputs)
});